import { APP_URL } from "./config";

export type ToolDef = {
    label: string;
    toolType: string;
    appHref: string;
    /** Internal landing page route (e.g. /background-replacer). Used for footer/nav SEO links. */
    landingHref?: string;
};

export const ALL_TOOLS: ToolDef[] = [
    // Photoshoot
    {
        label: "Background replacer",
        toolType: "product_photoshoot",
        appHref: `${APP_URL}/photoshoot?tool=product_photoshoot`,
        landingHref: "/background-replacer",
    },
    // {
    //     label: "Product showcase",
    //     toolType: "product_lifestyle_photoshoot",
    //     appHref: `${APP_URL}/photoshoot?tool=product_lifestyle_photoshoot`,
    //     landingHref: "/product-showcase",
    // },
    {
        label: "Virtual Try-On",
        toolType: "fashion_cloth_tryon",
        appHref: `${APP_URL}/photoshoot?tool=fashion_cloth_tryon`,
        landingHref: "/virtual-try-on",
    },
    {
        label: "Ghost mannequin",
        toolType: "fashion_ghost_mannequin",
        appHref: `${APP_URL}/photoshoot?tool=fashion_ghost_mannequin`,
        landingHref: "/ghost-mannequin",
    },
    {
        label: "Flat-lay",
        toolType: "fashion_flat_lay",
        appHref: `${APP_URL}/photoshoot?tool=fashion_flat_lay`,
        landingHref: "/flat-lay",
    },
    {
        label: "Fashion Catalogue",
        toolType: "fashion_catalogue_builder",
        appHref: `${APP_URL}/photoshoot?tool=fashion_catalogue_builder`,
    },
    // Edit
    {
        label: "Remove background",
        toolType: "image_background_remove",
        appHref: `${APP_URL}/edit?tool=image_background_remove`,
        landingHref: "/remove-background",
    },
    {
        label: "Upscale",
        toolType: "image_upscale",
        appHref: `${APP_URL}/edit?tool=image_upscale`,
        landingHref: "/upscale",
    },
    {
        label: "Resize",
        toolType: "image_resize",
        appHref: `${APP_URL}/edit?tool=image_resize`,
        landingHref: "/resize",
    },
    {
        label: "Edit with AI",
        toolType: "image_edit",
        appHref: `${APP_URL}/edit?tool=image_edit`,
        landingHref: "/edit-with-ai",
    },
    // Video
    {
        label: "Product videos",
        toolType: "product_video",
        appHref: `${APP_URL}/videos`,
        landingHref: "/product-videos",
    },
    {
        label: "Talking avatars",
        toolType: "talking_avatar",
        appHref: `${APP_URL}/videos`,
        landingHref: "/talking-avatars",
    },
    {
        label: "UGC videos",
        toolType: "ugc_video",
        appHref: `${APP_URL}/videos`,
        landingHref: "/ugc-videos",
    },
    {
        label: "Upscale video",
        toolType: "video_upscale",
        appHref: `${APP_URL}/videos`,
        landingHref: "/upscale-video",
    },
    {
        label: "Caption videos",
        toolType: "caption_video",
        appHref: `${APP_URL}/videos`,
        landingHref: "/caption-videos",
    },
    {
        label: "AI Fashion reels",
        toolType: "fashion_reel",
        appHref: `${APP_URL}/videos`,
        landingHref: "/fashion-reels",
    },
    {
        label: "CGI videos",
        toolType: "cgi_video",
        appHref: `${APP_URL}/videos`,
        landingHref: "/cgi-videos",
    },
];

const LIVE_TOOL_TYPES = new Set([
    "fashion_ghost_mannequin",
    "fashion_flat_lay",
    "fashion_cloth_tryon",
    "product_photoshoot",
    "image_upscale",
    "image_resize",
    "image_background_remove",
    "image_edit",
]);

export const LIVE_TOOLS = ALL_TOOLS.filter((t) =>
    LIVE_TOOL_TYPES.has(t.toolType),
);

export const toolAppHref = (label: string): string =>
    ALL_TOOLS.find((t) => t.label === label)?.appHref ?? `${APP_URL}`;

/** Returns the SEO landing page href for a tool, or falls back to appHref. */
export const toolLandingHref = (label: string): string => {
    const tool = ALL_TOOLS.find((t) => t.label === label);
    return tool?.landingHref ?? tool?.appHref ?? `${APP_URL}`;
};
